import { pipe, rawTransform } from 'valibot';
import { MixedOneSearchGraphQlResponse } from '../../../types/one-search/onesearch-response/OneSearchGraphQlResponse';
import { TechnicalInformation } from '../../../types/one-search/queries';
import { handleSrpUrl } from '../../../util/HandleUrls';
import { SchemaAny } from '../../VehicleTileDataSchema';
import { generatePrices } from '../../helper/prices';
import { SimplePriceVehicleDataFormat } from '../../simple-price/SimplePriceTransformer';

export const ConvertOneSearchGraphQlToSimplePriceVehicleDataTransformer = pipe(
  SchemaAny,
  rawTransform<MixedOneSearchGraphQlResponse, SimplePriceVehicleDataFormat>(({ dataset, addIssue, NEVER }) => {
    if (!dataset || !dataset.value) {
      addIssue({
        message: 'issues in ConvertOneSearchSearchToPreferenceTransformer',
        path: [
          {
            type: 'object',
            origin: 'value',
            input: dataset.value as unknown as Record<string, unknown>,
            key: 'results',
            value: dataset.value,
          },
        ],
      });
      return NEVER;
    }

    const url = handleSrpUrl(
      dataset.value.url,
      dataset.value.rawData?.ctaUrl,
      {
        sortByLeasingrate: dataset.value.rawData?.sortByLeasingrate,
      },
      dataset.value.ctx,
    );
    const dcpProductType = dataset.value?.identification?.dcpProductType;
    if (!dcpProductType) {
      addIssue({
        message: 'dcpProductType is not available',
        path: [
          {
            type: 'object',
            origin: 'value',
            input: dataset.value as Record<string, unknown>,
            key: 'results',
            value: dataset.value,
          },
        ],
      });
      return NEVER;
    }
    return {
      heading: dataset.value.rawData?.tileHeadline !== null ? dataset.value.rawData?.tileHeadline : '',
      description: dataset.value.rawData?.tileDescription !== null ? dataset.value.rawData?.tileDescription : '',
      image:
        dataset.value.rawData?.croppedimage !== null
          ? {
              url: dataset.value.rawData?.croppedimage?.sources?.mq1,
              alt:
                dataset.value.rawData?.croppedimage?.description !== null
                  ? dataset.value.rawData?.croppedimage?.description
                  : '',
              title:
                dataset.value.rawData?.croppedimage?.title !== null ? dataset.value.rawData?.croppedimage?.title : '',
            }
          : undefined,

      cta: {
        label: dataset.value.rawData?.ctaLabel,
        srp: url,
      },
      tag: {
        badges: [
          {
            showIcon: false,
            badges: dataset.value.rawData?.recommendationBadge
              ? {
                  name: dataset.value.rawData?.recommendationBadge?.name,
                  description:
                    dataset.value.rawData?.recommendationBadge?.description !== null
                      ? dataset.value.rawData?.recommendationBadge?.description
                      : '',
                  footnote:
                    dataset.value.rawData?.recommendationBadge?.footnote !== null
                      ? dataset.value.rawData?.recommendationBadge?.footnote
                      : '',
                }
              : {},
          },
        ],
      },
      prices: {
        prices: generatePrices({
          productCode: dataset.value.identification?.code as string,
          commissionNumber: dataset.value.identification?.commissionNumber as string,
          dcpProductType: dcpProductType,
          productType: 'STOCK',
          market: dataset.value.market,
          locale: dataset.value.lang,
          currency: undefined,
          priceRawValue: undefined, // TODO:  dataset.value.price?.grossValue ?? no clue, what data we should use. No prices in de_AT. Call fails in en_MY
        }),
      },
      mixedOneSearchResponse: {
        productCode: dataset.value?.identification?.code as string,
        vehicleName: dataset.value?.vehicleModel?.name as string,
        vehicleImages: dataset.value.images?.exterior as string[],
        technicalInformation: dataset.value?.technicalInformation as TechnicalInformation,
        emissionAndConsumption: dataset.value?.emissionAndConsumption,
        envkv: dataset.value?.envkv,
        dcpProductType: dataset.value?.identification?.dcpProductType as string,
        productCategory: dataset.value?.vehicleModel?.category?.value as string,
        commissionNumber: dataset.value?.identification?.commissionNumber as string,
        srpUrl: dataset.value.url,
        mode: dataset.value.mode,
        market: dataset.value.market,
        lang: dataset.value.lang,
        translations: dataset.value.translations,
        brand: dataset.value.brand,
        responseTypeId: 'OneSearchGraphQlVehicle',
      },
      common: {
        common: {
          hasCriticalError: false,
          brand: dataset.value.brand,
          productType: 'STOCK',
          bm6: dataset.value?.vehicleModel?.baumuster as string,
          modelIdentifier: dataset.value?.vehicleModel?.vehicleClass?.value as string,
          bodyType: dataset.value?.vehicleModel?.bodyType?.value as string,
          vehicleName: dataset.value?.vehicleModel?.name as string,
          identification: {
            commissionNumber: dataset.value.identification?.commissionNumber as string,
            productCode: (dataset.value?.identification?.code as string) ?? 'no code',
            configurationId: undefined,
          },
          isVan: dataset.value.vehicleModel?.category?.value === 'PC' ? false : true,
        },
      },
    };
  }),
);
